import ApplicationApiError from "../../../../foundation/ApplicationApiError"
import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { CorporationBillingDestinationView } from "~/backendApis/viewModel"

interface Params {
  universalCorporationId: string
}

export class GetCurrentBillingDestinationReadRequest extends ReadRequest<CorporationBillingDestinationView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<CorporationBillingDestinationView | null> {
    return this.apiClient
      .get(this.makeEndpoint())
      .catch((e: ApplicationApiError) => {
        if (e.isNotFoundError()) {
          return null
        }
        throw e
      })
  }

  private makeEndpoint(): string {
    return `/corporation_contract/corporation_member/${this.params.universalCorporationId}/billing_destination/show`
  }
}
